export default {
  options: {
    none: 'Niciun cod promoțional pentru început',
  },
  buttons: {
    next: 'Următor',
    back: 'Înapoi',
    skip: 'Omiteți',
  },
};
